/*
 * История обращения: та же лента, что в профиле клиента, но для человека,
 * у которого дела ещё нет. Таких в системе большинство — 107 из 109.
 *
 * 🔴 ЗДЕСЬ ЖИВУТ ТРИ ДЕЙСТВИЯ НАД ОБРАЩЕНИЕМ (quick-260911-27v, Д-04).
 *    До 11.09.2026 на этой карточке не было НИ ОДНОГО действия, а `Delete` и
 *    `Convert to Client` стояли в КАЖДОЙ строке списка: на ста строках — сто
 *    разрушительных кнопок под курсором, причём `Convert` без подтверждения
 *    вовсе. Возможности не потеряны — они переехали туда, где человек смотрит
 *    на ОДНО обращение и видит его целиком.
 *
 * 🔴 КАРТОЧКА ОБЩАЯ НА ВСЕХ АРЕНДАТОРОВ, и действия появляются у всех четверых
 *    (mlg · fitenko · eln · elfny). Это сказано вслух, а не умолчано: рубежа
 *    арендатора здесь нет и раньше не было. Захочет владелец гейтить — это
 *    правка в одну строку, и она его решение, а не наше.
 *
 * 🔴 КОРЗИНЫ УДАЛЁННЫХ ОБРАЩЕНИЙ В ИНТЕРФЕЙСЕ НЕТ. Ручки существуют —
 *    `GET /leads/deleted` (leads.py:83) и `POST /leads/{id}/restore`
 *    (leads.py:547), — но потребителей во фронте у них НОЛЬ (проверено грепом).
 *    Значит удаление обратимо в базе и НЕОБРАТИМО для человека. Это НАЗВАННАЯ
 *    граница, а не починка: экран восстановления — отдельная задача.
 */
import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-hot-toast';

import HistoryTimeline from '../components/history/HistoryTimeline';
import apiService from '../services/apiService';
import { LeadEditModal } from './LeadsPage';

const LeadHistoryPage = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [history, setHistory] = useState(null);
    const [lead, setLead] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [pravim, postavitPravim] = useState(false);
    const [zanyato, postavitZanyato] = useState(false);

    useEffect(() => {
        let cancelled = false;
        setLoading(true);
        setError(null);
        apiService.getLeadHistory(id)
            .then((data) => { if (!cancelled) setHistory(data); })
            .catch((e) => { if (!cancelled) setError(e.message); })
            .finally(() => { if (!cancelled) setLoading(false); });
        return () => { cancelled = true; };
    }, [id]);

    // Само обращение спрашивается ОТДЕЛЬНО: подтверждение разрушительного
    // действия обязано называть ПОСЛЕДСТВИЕ поимённо, а для этого нужен адрес
    // почты. Лента его не несёт.
    useEffect(() => {
        let cancelled = false;
        apiService.getLead(id)
            .then((d) => { if (!cancelled) setLead(d); })
            .catch(() => { if (!cancelled) setLead(null); });
        return () => { cancelled = true; };
    }, [id]);

    const imya = (lead && lead.full_name) || (history && history.display_name) || `Обращение №${id}`;

    const perevesti = useCallback(async () => {
        // 🔴 ЭТО ДЕЙСТВИЕ НЕ БЕЗОБИДНО: оно создаёт учётную запись с временным
        //    паролем и ОТПРАВЛЯЕТ ПИСЬМО (leads.py:287-386).
        const adres = (lead && lead.email) || 'адрес не известен — письмо может не уйти';
        const soglasie = window.confirm(
            `Перевести «${imya}» в клиенты?\n\n`
            + `ЧТО ПРОИЗОЙДЁТ СЕЙЧАС ЖЕ:\n`
            + `• будет создана учётная запись клиента;\n`
            + `• будет автоматически заведено новое юридическое дело;\n`
            + `• на адрес ${adres} уйдёт письмо с доступом в портал.\n\n`
            + `Создать клиента и открыть дело?`);
        if (!soglasie) return;
        postavitZanyato(true);
        try {
            const otvet = await apiService.convertLead(id);
            toast.success(otvet.message || 'Обращение переведено в клиенты и заведено дело!');
            setLead((b) => (b ? { ...b, status: 'CONVERTED', case_id: otvet.case_id } : b));
            if (otvet.case_id) {
                toast(`Открываю созданное дело №${otvet.case_id}...`, { icon: '📂' });
                setTimeout(() => navigate(`/cases/${otvet.case_id}`), 800);
            }
        } catch (e) {
            toast.error(`Перевести не удалось: ${e.message}`);
        } finally {
            postavitZanyato(false);
        }
    }, [id, imya, lead, navigate]);

    const udalit = useCallback(async () => {
        const soglasie = window.confirm(
            `Удалить обращение «${imya}»?\n\n`
            + `Удаление МЯГКОЕ: строка остаётся в базе вместе с лентой, сообщениями\n`
            + `и звонками, и с показа она просто исчезает.\n\n`
            + `🔴 НО ЭКРАНА ВОССТАНОВЛЕНИЯ В ИНТЕРФЕЙСЕ НЕТ. Вернуть обращение\n`
            + `самостоятельно вы НЕ СМОЖЕТЕ — только через разработчика.`);
        if (!soglasie) return;
        postavitZanyato(true);
        try {
            await apiService.deleteLead(id);
            toast.success(`Обращение «${imya}» удалено.`);
            navigate('/leads');
        } catch (e) {
            toast.error(`Удалить не удалось: ${e.message}`);
            postavitZanyato(false);
        }
    }, [id, imya, navigate]);

    const svyazannoeDeloId = (lead && lead.case_id) || (history && history.case_ids && history.case_ids[0]);

    return (
        <div className="page-container" style={{ padding: '24px' }}>
            {pravim && lead ? (
                <LeadEditModal
                    lead={lead}
                    onClose={() => postavitPravim(false)}
                    onSave={(obnovlennoe) => setLead(obnovlennoe)}
                />
            ) : null}

            <button
                className="btn-secondary"
                onClick={() => navigate(-1)}
                style={{ marginBottom: '16px' }}
            >
                ← Назад
            </button>

            <h1 style={{ margin: '0 0 4px', fontSize: '22px' }}>
                {history?.display_name || `Обращение №${id}`}
            </h1>
            <p style={{ margin: '0 0 8px', opacity: 0.6, fontSize: '13px' }}>
                Обращение №{id}
                {history?.case_ids?.length ? ` · дел: ${history.case_ids.length}` : ' · дела ещё нет'}
            </p>

            {/* ДЕЙСТВИЯ НАД ОДНИМ ОБРАЩЕНИЕМ */}
            {lead ? (
                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', margin: '0 0 16px', alignItems: 'center' }}>
                    <button type="button" className="btn btn-secondary btn-sm"
                            disabled={zanyato} onClick={() => postavitPravim(true)}>
                        Изменить
                    </button>
                    {String(lead.status).toLowerCase() !== 'converted' ? (
                        <button type="button" className="btn btn-primary btn-sm"
                                disabled={zanyato}
                                title="Создаст учетную запись и новое дело в 1 клик"
                                onClick={perevesti}>
                            ⚡ Перевести в дело
                        </button>
                    ) : (
                        svyazannoeDeloId && (
                            <button
                                type="button"
                                className="btn btn-sm"
                                style={{
                                    background: '#20231F',
                                    color: '#FAF4E5',
                                    border: '1px solid #C8A653',
                                    fontWeight: '600',
                                    cursor: 'pointer'
                                }}
                                onClick={() => navigate(`/cases/${svyazannoeDeloId}`)}
                            >
                                📂 Открыть дело №{svyazannoeDeloId} →
                            </button>
                        )
                    )}
                    <button type="button" className="btn btn-danger btn-sm"
                            disabled={zanyato} onClick={udalit}>
                        Удалить
                    </button>
                </div>
            ) : null}

            <HistoryTimeline history={history} loading={loading} error={error} />
        </div>
    );
};

export default LeadHistoryPage;
